import { fetchLatestUserAccessOverrideEvent, fetchSuperuserAccessByEmployee } from "../api/userAccess";
import { ADMIN_ACCESS, EMPLOYEE_ACCESS, MULTI_STATION_ADMIN_ACCESS, NO_ACCESS, VALID_SWA_STATIONS } from "./constants";
import { getEmployeeId, getEmployeeJobCode, getEmployeeActiveStation } from "./employeeDataRetriever";
import { getDefaultUserAccessGiveJobCode } from "./workgroupMapper";

export async function getUserAccessRole(data) {
  // Using employee service data and the user_access_override, we can
  // determine exactly what the user's role should be.

  // Get the default role...
  let userEid = getEmployeeId(data);
  let userRole = getDefaultUserAccessGiveJobCode(getEmployeeJobCode(data));
  let userActiveStation = getEmployeeActiveStation(data);
  let multiStationAdminStationList = [];

  if (userRole === NO_ACCESS || !VALID_SWA_STATIONS().includes(userActiveStation) || !data.isActive) {
    return [NO_ACCESS, multiStationAdminStationList];
  }

  // Pull the user_access_override data for the user
  var response = await fetchLatestUserAccessOverrideEvent(userEid, userActiveStation).then((res) => res.json());

  if (response.userAccessOverrideEvent !== null) {
    userRole = getUserRoleFromUserAccessOverrideEvent(response.userAccessOverrideEvent);
    multiStationAdminStationList = response.userAccessOverrideEvent.multiStationAdminStationList;
  }

  return [userRole, multiStationAdminStationList];
}

function getUserRoleFromUserAccessOverrideEvent(event) {
  if (event.isEmployee) {
    return EMPLOYEE_ACCESS;
  } else if (event.isAdmin) {
    return ADMIN_ACCESS;
  } else if (event.isMultiStationAdmin) {
    return MULTI_STATION_ADMIN_ACCESS;
  }
  return "";
}

export async function getSuperuserAccess(data) {
  // Get the default role...
  let userEid = getEmployeeId(data);

  // Pull the user_access_override data for the user's station
  var response = await fetchSuperuserAccessByEmployee(userEid).then((res) => res.json());

  if (response.superuserAccessRows.Count > 0) {
    return [true, buildSuperuserStationList(response.superuserAccessRows.Items)];
  }

  return [false, []];
}

function buildSuperuserStationList(superuserRows) {
  let superuserStationList = [];
  for (let i = 0; i < superuserRows.length; i++) {
    let currRow = superuserRows[i];
    superuserStationList.push(currRow.station);
  }
  return superuserStationList;
}
